export default __webpack_public_path__ + "static/media/cadastroMobile.7e8246b6.png";